import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Images } from "config/images";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: theme.palette.primary.main,
				backgroundImage: `url(${Images.bgLogin})`,
				backgroundRepeat: "no-repeat",
				backgroundSize: "100% 100%",
				width: "100%",
				height: "100vh"
			},
			header: {
				padding: "48px 27px 15px"
			},
			nameCompany: {
				fontSize: 20,
				color: theme.palette.primary.contrastText,
				fontWeight: 500,
				marginTop: 8
			},
			subTitle: {
				color: theme.palette.grey[50],
				fontSize: 12,
				marginTop: 8
			},
			rootForm: {
				background: theme.palette.common.white,
				height: "calc(100% - 143px)",
				borderRadius: "50px 50px 0px 0px",
				position: "relative"
			},
			form: {
				padding: "70px 27px"
			},
			customInput: {
				color: theme.palette.secondary.contrastText,
				"& > .MuiInput-root": {
					border: `1px solid ${theme.palette.grey[800]}`,
					borderRadius: 6
				},
				height: "100%",
				width: "100%",
				"& > div > input": {
					height: 35,
					fontSize: "16px !important",
					width: "80%",
					"-webkit-box-shadow": "0 0 0 30px white inset !important"
				},
				"& > .MuiInput-underline:before": {
					borderBottom: `1px solid ${theme.palette.grey["A100"]}`,
					content: "none"
				},
				"& > .MuiInput-underline:after": {
					content: "none",
					borderBottom: `1px solid ${theme.palette.grey["A100"]}`
				}
			},
			inputError: {
				border: `1px solid ${theme.palette.error.main} !important`,
				borderRadius: "6px !important"
			},
			mt15: {
				marginTop: 15
			},
			bodyBtnSubmit: {
				display: "flex",
				justifyContent: "center",
				marginTop: 30
			},
			btnSubmit: {
				background: theme.palette.primary.main,
				color: theme.palette.text.contrastText,
				fontSize: 14,
				textTransform: "capitalize",
				width: "100%",
				height: 46,
				borderRadius: 6,
				"&:active": {
					opacity: 0.7,
					background: theme.palette.primary.main
				},
				"&:hover": {
					background: theme.palette.primary.main
				}
			},
			btnDefault: {
				color: theme.palette.secondary.main,
				fontSize: 14,
				textAlign: "center",
				marginTop: 30,
				cursor: "pointer",
				"&:hover": {
					opacity: 0.7
				}
			},
			textError: {
				fontSize: 12,
				marginLeft: 20,
				marginTop: 5,
				color: theme.palette.error.main
			},
			logoFooter: {
				position: "absolute",
				bottom: 0,
				right: 0
			}
		}),
	{
		name: "LoginPage",
		index: 1
	}
);

export default useStyles;
